import { ReactElement } from 'react';
import { useCart } from '../../../contexts/Cart';
import RecipeImage from './RecipeImage';
import RecipeActions from './RecipeActions';
import { toCurrency } from '../../../utils/numbers';
import ISku from '../../../models/ISku';

type Props = {
    sku: ISku;
};

function ProgramRecipe({
  sku,
}: Props): ReactElement {
  const { cart } = useCart();
  const cartIdFromContext = cart.id;

  const {
    title,
    servings,
    calories,
    subtitle,
    id: skuId,
    image_versions: imageVersions,
    link_to_product: linkToProduct,
    subscription_price_per_serving: subscriptionPricePerServing,
  } = sku;

  const cartProduct = cart.products.find((product) => product.items[0].sku.id === sku.id);
  const {
    quantity,
    sale_tag_enabled: salesTagEnabled,
    sold_out: soldOut,
    isSoldOut,
    // @ts-expect-error TODO: fix null safety
  } = cartProduct.currentItem;

  // TODO: we should not have 2 different values for sold out
  const isProgramItemSoldOut = soldOut || isSoldOut;

  const linkWithCartId = `${linkToProduct}?cart_id=${cartIdFromContext}`;
  const totalPrice = toCurrency(subscriptionPricePerServing * (servings ?? 0));

  return (
    <div
      className={[
        'c-programs-cart-page__container',
        quantity > 0 ? 'is-selected c-programs-cart-page__is-selected' : '',
        isProgramItemSoldOut ? 'is-sold-out' : '',
      ].join(' ')}
    >
      <RecipeImage
        imageVersions={imageVersions}
        title={title}
        salesTagEnabled={salesTagEnabled}
        isProgramPage
      />

      <div className="c-programs-cart-page__recipe-content">
        <div className="c-recipe__type">Ready to Eat</div>
        <a id={`recipe-title-${skuId}`} href={linkWithCartId}>
          <div className="c-recipe__programs-title">{title}</div>
          <span className="c-recipe__subtitle">{subtitle}</span>
        </a>
      </div>

      <div className="c-programs-cart-page__price">
        <span>
          <span className="c-price__amount">{totalPrice}</span>
          <span className="c-price__unit"> / each </span>
          {!!calories && (
          <span>
            <span style={{ fontWeight: 900 }}>· </span>
            {`${calories} cal`}
          </span>
          )}
        </span>
      </div>

      <RecipeActions
          // @ts-expect-error TODO: fix null safety
        cartProduct={cartProduct}
        menuId={cart.menu_id}
        isProgramPage
      />
    </div>
  );
}

export default ProgramRecipe;
